import MainLayout from "../components/layout/MainLayout";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";

import Banner from "../components/organisms/Banner";
import JobListingGridHome from "../components/organisms/JobListingGridHome";
import ClientListSection from "../components/organisms/ClientListSection";
import Testimonial from "../components/organisms/Testimonial";
import EventHome from "../components/organisms/EventHome";

import { useEffect } from "react";
import { useAuthStore } from "../store/useAuthStore";

export default function Home() {
  const { accessToken, type } = useAuthStore();

  useEffect(() => {
    document.title = "TalentLink | Home";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "Halaman utama TalentLink");
    }
  }, []);

  // Pilih layout sesuai login
  const Layout =
    !accessToken
      ? MainLayout
      : type === "candidate"
      ? MainLayoutUser
      : type === "company"
      ? MainLayoutAdmin
      : MainLayout;

  return (
    <Layout>
      <Banner />
      <JobListingGridHome />
      <ClientListSection />
      <Testimonial />
      <EventHome />
    </Layout>
  );
}
